import React, { useState, useCallback } from "react";
import "./Eligibility.css";
import SubjectSelector from "./SubjectSelector";
import ResultsDashboard from "./ResultsDashboard";

const EligibilityChecker = () => {
    const [selectedSubjects, setSelectedSubjects] = useState([]);
    const [showResults, setShowResults] = useState(false);

    const handleToggleSubject = useCallback((subject) => {
        setSelectedSubjects((prev) =>
            prev.includes(subject) ? prev.filter((s) => s !== subject) : [...prev, subject]
        );
    }, []);

    const handleRemoveSubject = useCallback((subject) => {
        setSelectedSubjects((prev) => prev.filter((s) => s !== subject));
    }, []);

    const handleShowResults = () => {
        if (selectedSubjects.length > 0) {
            setShowResults(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handleBack = () => {
        setShowResults(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleClearAll = () => {
        setSelectedSubjects([]);
    };

    return (
        <div className="elig-wrapper">
            <div className="elig-container">
                {!showResults ? (
                    <>
                        <div className="elig-page-header">
                            <h1 className="elig-page-header__title">
                                Step 1: Choose Your Subjects
                            </h1>
                            <p className="elig-page-header__subtitle">
                                Select the subjects you intend to appear for in the CUET exam. We will use this
                                combination to find your eligible colleges and courses.
                            </p>
                        </div>

                        <SubjectSelector
                            selectedSubjects={selectedSubjects}
                            onToggleSubject={handleToggleSubject}
                        />

                        <div className="elig-cta-section">
                            <button
                                className="elig-cta-btn"
                                onClick={handleShowResults}
                                disabled={selectedSubjects.length === 0}
                            >
                                Check Eligibility
                                <span className="elig-cta-btn__arrow">→</span>
                            </button>
                            {selectedSubjects.length > 0 && (
                                <button className="elig-clear-link" onClick={handleClearAll}>
                                    Clear All Selections
                                </button>
                            )}
                        </div>
                    </>
                ) : (
                    <ResultsDashboard
                        selectedSubjects={selectedSubjects}
                        onRemoveSubject={handleRemoveSubject}
                        onBack={handleBack}
                    />
                )}
            </div>
        </div>
    );
};

export default EligibilityChecker;
